export default "__VITE_ASSET__DX$iXcxl__"